import { esDO } from './es-DO';
import { esMX } from './es-MX';
import { esCO } from './es-CO';
import { enUS } from './en-US';
import type { SupportedLocale } from '../config';

export const MESSAGES: Record<SupportedLocale, Record<string, string>> = {
  'es-DO': esDO,
  'es-MX': esMX,
  'es-CO': esCO,
  'en-US': enUS,
};

export type { MessageKey } from './es-DO';
